var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogicApi = function SvgIconLogicApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 67.64,
    y1: 530.13,
    x2: 515.64,
    y2: 120.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 18.21,
    y1: 476.12,
    x2: 466.21,
    y2: 66.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 34.67,
    y1: 494.1,
    x2: 482.67,
    y2: 84.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 16.97,
    y1: 474.76,
    x2: 464.97,
    y2: 64.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 33.42,
    y1: 492.73,
    x2: 481.42,
    y2: 82.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15.72,
    y1: 473.39,
    x2: 463.72,
    y2: 63.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 32.17,
    y1: 491.37,
    x2: 480.17,
    y2: 81.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 127.24,
    y1: 595.26,
    x2: 575.24,
    y2: 185.26,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.32,90.84v66.06c0,13.66,11.12,24.77,24.77,24.77h132.13c13.66,0,24.77-11.12,24.77-24.77v-66.06c0-13.66-11.12-24.77-24.77-24.77h-33.25c5.24-6.92,8.47-15.44,8.47-24.77,0-22.77-18.52-41.29-41.29-41.29-19.93,0-36.62,14.21-40.46,33.03h-91.67c-22.77,0-41.29,18.52-41.29,41.29v75.16c-16.15,3.29-28.9,16.05-32.2,32.2h-91.67c-22.77,0-41.29,18.52-41.29,41.29v75.16c-18.82,3.84-33.03,20.52-33.03,40.46,0,9.33,3.23,17.85,8.47,24.77H24.77c-13.66,0-24.77,11.12-24.77,24.77v66.06c0,13.66,11.12,24.77,24.77,24.77h132.13c13.66,0,24.77-11.12,24.77-24.77v-66.06c0-13.66-11.12-24.77-24.77-24.77h-33.25c5.24-6.92,8.47-15.44,8.47-24.77,0-19.93-14.21-36.62-33.03-40.46v-75.16c0-13.66,11.12-24.77,24.77-24.77h91.67c1.26,6.14,3.98,11.69,7.63,16.52h-33.24c-13.66,0-24.77,11.12-24.77,24.77v66.06c0,13.66,11.12,24.77,24.77,24.77h65.07c-.52,1.46-1.07,2.91-1.54,4.39l-22.25,5.72v62.36l22.25,5.71c2.22,7.13,5.07,14.02,8.51,20.58l-11.69,19.75,44.1,44.1,19.75-11.68c6.57,3.44,13.46,6.29,20.59,8.51l5.71,22.24h62.36l5.71-22.24c7.13-2.22,14.01-5.07,20.59-8.51l19.75,11.68,44.1-44.1-11.69-19.75c3.44-6.56,6.28-13.44,8.51-20.58l22.25-5.72v-62.36l-22.25-5.71c-2.22-7.13-5.07-14.02-8.51-20.58l11.69-19.74-44.1-44.1-19.75,11.69c-6.56-3.44-13.45-6.28-20.59-8.51l-5.71-22.25h-57.48c-3.42-9.59-12.5-16.52-23.25-16.52h-33.25c5.24-6.92,8.47-15.44,8.47-24.77,0-19.93-14.21-36.62-33.03-40.46v-75.16c0-13.66,11.12-24.77,24.77-24.77h91.67c1.26,6.14,3.98,11.69,7.63,16.52h-33.24c-13.66,0-24.77,11.12-24.77,24.77ZM156.9,379.87c4.55,0,8.26,3.7,8.26,8.26v66.06c0,4.56-3.71,8.26-8.26,8.26H24.77c-4.55,0-8.26-3.7-8.26-8.26v-66.06c0-4.56,3.71-8.26,8.26-8.26h132.13ZM115.61,338.58c0,13.66-11.12,24.77-24.77,24.77s-24.77-11.12-24.77-24.77,11.12-24.77,24.77-24.77,24.77,11.12,24.77,24.77ZM346.84,247.74h43.14l4.9,19.08,4.65,1.25c9,2.42,17.61,5.98,25.58,10.57l4.18,2.41,16.92-10.02,25.98,25.98-10.01,16.94,2.41,4.18c4.59,7.95,8.15,16.56,10.57,25.58l1.26,4.65,19.07,4.89v36.74l-19.07,4.9-1.26,4.65c-2.42,9.02-5.99,17.62-10.57,25.58l-2.41,4.18,10.01,16.94-25.98,25.97-16.92-10.01-4.18,2.41c-7.98,4.6-16.58,8.16-25.58,10.57l-4.66,1.25-4.9,19.08h-36.73l-4.9-19.08-4.66-1.25c-8.99-2.41-17.6-5.98-25.58-10.57l-4.18-2.41-16.92,10.01-25.98-25.97,10.01-16.94-2.41-4.18c-4.59-7.95-8.15-16.56-10.57-25.58l-1.26-4.65-19.07-4.89v-36.74l19.07-4.9,1.26-4.65c1.23-4.58,2.86-9.03,4.67-13.37h17.97c-6.51,12.68-9.93,26.71-9.93,41.28,0,50.09,40.75,90.84,90.84,90.84s90.84-40.75,90.84-90.84-40.75-90.84-90.84-90.84c-8.48,0-16.76,1.25-24.77,3.52v-36.55ZM346.84,305.55v-3.95c7.93-2.81,16.23-4.31,24.77-4.31,40.98,0,74.32,33.34,74.32,74.32s-33.35,74.32-74.32,74.32-74.32-33.34-74.32-74.32c0-14.89,4.37-29.06,12.58-41.29h12.2c13.66,0,24.77-11.12,24.77-24.77ZM322.06,231.23c4.55,0,8.26,3.71,8.26,8.26v66.06c0,4.56-3.71,8.26-8.26,8.26h-132.13c-4.55,0-8.26-3.7-8.26-8.26v-66.06c0-4.55,3.71-8.26,8.26-8.26h132.13ZM280.77,189.94c0,13.66-11.12,24.77-24.77,24.77s-24.77-11.12-24.77-24.77,11.12-24.77,24.77-24.77,24.77,11.12,24.77,24.77ZM421.16,16.52c13.66,0,24.77,11.12,24.77,24.77s-11.12,24.77-24.77,24.77-24.77-11.12-24.77-24.77,11.12-24.77,24.77-24.77ZM487.23,82.58c4.55,0,8.26,3.71,8.26,8.26v66.06c0,4.55-3.71,8.26-8.26,8.26h-132.13c-4.55,0-8.26-3.71-8.26-8.26v-66.06c0-4.55,3.71-8.26,8.26-8.26h132.13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 363.35,
    y: 99.1,
    width: 115.61,
    height: 16.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 363.35,
    y: 132.13,
    width: 115.61,
    height: 16.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 198.19,
    y: 247.74,
    width: 115.61,
    height: 16.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 198.19,
    y: 280.77,
    width: 115.61,
    height: 16.52
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 33.03,
    y: 396.39,
    width: 115.61,
    height: 16.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.03,
    y: 429.42,
    width: 115.61,
    height: 16.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.61,412.9c22.77,0,41.29-18.52,41.29-41.29s-18.52-41.29-41.29-41.29-41.29,18.52-41.29,41.29,18.52,41.29,41.29,41.29ZM371.61,346.84c13.66,0,24.77,11.12,24.77,24.77s-11.12,24.77-24.77,24.77-24.77-11.12-24.77-24.77,11.12-24.77,24.77-24.77Z"
  })));
};
export default SvgIconLogicApi;